import type { IBrandConfig } from './types';

const PROTECTIV_BRAND_CONFIG: IBrandConfig = {
  privacyPolicy: {
    kind: 'external',
    url: 'https://www.iv.lt/privatumo-politika',
  },
  termsOfService: {
    kind: 'external',
    url: 'https://www.iv.lt/bendrosios-paslaugu-teikimo-salygos',
  },
  websiteTermsOfUse: { kind: 'none' },
  refundPolicy: { kind: 'none' },
  idTheftProtection: { kind: 'none' },
  licensor: 'intersections',
  vaultProject: 'protectiv',
  adaChat: false,
  accountDetails: true,
  personalInformation: false,
  secureUpload: false,
  plan: false,
  security: false,
  missingPII: false,
  finishSetup: false,
  defaultBillingCategoryKey: 'privacy_breach',
  copyRightEntity: 'UAB „Interneto vizija',
  hasCustomerServiceSupport: false,
  ssoRedirectURL: null,
  carouselBanners: false,
  dwEmailVerification: {
    adaChat: false,
    signInButton: true,
    supportAt: null,
    availability: null,
  },
  supportPage: {
    pageTitle: {
      active: false,
    },
    faq: {
      active: true,
    },
    pages: [
      {
        title: 'Support page',
        href: 'https://pagalba.iv.lt/lt',
        icon: 'support-faq',
        customerSupport: false,
      },
    ],
    call: {},
    mail: {
      active: false,
    },
    email: {
      active: true,
      address: 'info@iv.lt',
      customerSupport: true,
    },
  },
};

export default PROTECTIV_BRAND_CONFIG;
